export const logger = {
  // [existing logger implementation]
  debug: (message: string) => {
    const debugLevel = parseInt(
      import.meta.env.VITE_AZURE_AUTH_DEBUG_LEVEL || '3',
    );
    if (debugLevel <= 0) console.debug(message);
  },
  info: (message: string) => {
    const debugLevel = parseInt(
      import.meta.env.VITE_AZURE_AUTH_DEBUG_LEVEL || '3',
    );
    if (debugLevel <= 1) console.info(message);
  },
  warn: (message: string) => {
    const debugLevel = parseInt(
      import.meta.env.VITE_AZURE_AUTH_DEBUG_LEVEL || '3',
    );
    if (debugLevel <= 2) console.warn(message);
  },
  error: (message: string) => {
    console.error(message);
  },
};
